<template>
   <div
     class="discover-beauty-class"
     :class="{ 'no-top-padding': isMobileApp }"
   >
     <Banner page='beauty_class_index_page' />
     <BeautyClasses :beauty-classes='filteredClasses' />
     <div class="empty-view"
       v-if="beautyClasses.length === 0"
       v-html="$t('bookingService.empty')"
     />
   </div>
</template>

<i18n>
{
  "lng_en": {
    "bookingService": {
      "metaDescription": "Discover more in Sephora stores, from the latest in-store promotions to exciting new launches and meet and greet sessions with your favourite brand owners.",
      "empty": "There are currently no beauty classes. Please check back soon."
    }
  },
  "lng_id": {
    "bookingService": {
      "metaDescription": "Discover more in Sephora stores, from the latest in-store promotions to exciting new launches and meet and greet sessions with your favourite brand owners.",
      "empty": "There are currently no beauty classes. Please check back soon."
    }
  },
  "lng_zh": {
    "bookingService": {
      "metaDescription": "Discover more in Sephora stores, from the latest in-store promotions to exciting new launches and meet and greet sessions with your favourite brand owners.",
      "empty": "目前沒有美容課程。請密切留意。"
    }
  },
  "lng_th": {
    "bookingService": {
      "metaDescription": "ค้นพบความตื่นเต้นเร้าใจที่ร้านเซโฟราไปกับกิจกรรมเปิดตัวแบรนด์ใหม่พร้อมพบกับผู้ก่อตั้งแบรนด์ชื่อดังมากมายที่คุณชื่นชอบ.",
      "empty": "ขณะนี้ไม่มีคลาสเสริมความงาม โปรดกลับมาดูอีกครั้งในเร็ว ๆ นี้"
    }
  },
  "lng_ko": {
    "bookingService": {
      "metaDescription": "현재 진행중인 매장 프로모션부터 신제품 출시 소식, 기다리던 브랜드의 이벤트까지, 세포라의 오프라인 스토어에서 더 많은 경험을 즐겨보세요. ",
      "empty": "현재 미용 수업이 없습니다. 나중에 다시 확인해주세요. "
    }
  }
}
</i18n>

<script>
import { mapGetters, createNamespacedHelpers } from 'vuex'
import Banner from './reusable/banner.vue'
import BeautyClasses from './reusable/beauty-classes.vue'
import { fullUrl } from '@/modules/services/utilities'

const { mapActions, mapState } = createNamespacedHelpers('bookingService')

export default {
  name: 'BeautyClassesIndex',
  components: { Banner, BeautyClasses },
  computed: {
    ...mapGetters(['isMobileApp']),
    ...mapState(['beautyClasses']),
    filteredClasses () {
      return this.beautyClasses.filter(beautyClasses => beautyClasses.attributes['status'] === 'published')
    }
  },
  beautyClasses () {
      const beautyClasses = this.store.relationships['beauty-classes']
      return beautyClasses.data ? beautyClasses.data.map(bc => this.objectById('beautyClasses', bc.id)) : []
    },
  mounted () {
    this.fetchBeautyClasses()
    this.$store.commit('setSeoMetaTitle', this.$t('retailStore.classes'))
    this.$store.commit('setSeoMetaDescription', this.$t('bookingService.metaDescription'))
    this.$store.commit('setSeoOgUrl', fullUrl(this.$route.path))
    this.$store.commit('setSeoUpdate', true)
  },
  methods: {
    ...mapActions(['fetchBeautyClasses'])
  }
}
</script>
mounted
<style scoped lang='scss'>
  .discover-beauty-class {
    @include media-breakpoint-down(md) {
      padding-right: 5px;
      padding-left: 5px;
    }

    @include media-breakpoint-down(sm) {
      padding: 10px;
    }

    &.no-top-padding {
      padding-top: 0;
    }

    .empty-view {
      padding-top: 16px;
      line-height: 18px;
    }
  }
</style>
